/* tslint:disable */
/* eslint-disable */
export enum NotificationEventType {
  ProjectCreated = 'projectCreated',
  ProjectEdited = 'projectEdited',
  ProjectDeleted = 'projectDeleted',
  WorkPackageCreated = 'workPackageCreated',
  WorkPackageEdited = 'workPackageEdited',
  WorkPackageDeleted = 'workPackageDeleted',
  AttachmentCreated = 'attachmentCreated',
  AttachmentEdited = 'attachmentEdited',
  AttachmentDeleted = 'attachmentDeleted'
}
